import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import accountService from "../../services/accountService";
import Location from "../../models/location";
import AccountLink from "../../components/work/AccountLink";
import LocationLink from "../../components/work/LocationLink";
import User from "../../models/user";
import UserContext from "../../contexts/userContext";
import SubscriptionContextModel from "../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../contexts/subscriptionContext";
import Page from "../../components/work/layout/Page";
import SearchBar from "../../components/work/layout/SearchBar";

const Locations: React.FC = () => {
  const navigate = useNavigate();
  const user = useContext<User | undefined>(UserContext);
  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [locations, setLocations] = useState<Location[]>([]);
  const [allLocations, setAllLocations] = useState<Location[]>([]);
  const [locationSearch, setLocationSearch] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        if (user) {
          const { data: locations } = await accountService.getLocations(
            subscription.idSubscription,
          );
          setLocations(locations);
          setAllLocations(locations);
        }
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, [user, subscription]);

  const onSearchChange = (event: any) => {
    setLocationSearch(event.target.value);
    const searchToken = event.target.value.toLowerCase();
    const newLocations = allLocations.filter(
      (l) =>
        l.locationName.toLowerCase().includes(searchToken) ||
        l.account.accountName.toLowerCase().includes(searchToken) ||
        l.siteManagerName.toLowerCase().includes(searchToken),
    );
    setLocations(newLocations);
  };

  const onCreateLocationClick = () => {
    navigate("/work/locations/new");
  };

  const onEditClick = (location: Location) => {
    navigate(`/work/locations/${location.idLocation}`);
  };

  return (
    <Page
      pageTitle="Locations"
      breadcrumbs={[{ linkName: "Locations", linkUlr: "" }]}
    >
      <section className="section">
        <div className="card">
          {/* <div className="card-header">
            <div className="d-flex align-items-center">
              <form className="search-form">
                <i className="bi bi-search search-icon"></i>
                <input
                  type="search"
                  name="q"
                  placeholder="Search locations..."
                  autoComplete="off"
                  value={locationSearch}
                  onChange={onSearchChange}
                />
              </form>
            </div>
            <div className="d-flex flex-column align-items-end">
              {subscription.canCreateAccounts && (
                <>
                  <button
                    className="btn btn-primary"
                    onClick={() => onCreateLocationClick()}
                  >
                    <i className="bi bi-plus-lg me-1"></i> Create Location
                  </button>
                </>
              )}
              <div
                style={{
                  visibility: locations.length > 0 ? "visible" : "hidden",
                }}
              >{`${locations.length} locations`}</div>
            </div>
          </div> */}

          <SearchBar
            placeHolderText="Search locations..."
            searchValue={locationSearch}
            onSearchChange={onSearchChange}
            hasCreate={subscription.canCreateAccounts}
            createTitle="Create Location"
            onCreate={() => onCreateLocationClick()}
            count={locations.length}
            countType="locations"
          />

          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover table-responsive">
                <thead>
                  <tr>
                    <th scope="col">Location Name</th>
                    <th scope="col">Account Name</th>
                    <th scope="col">Site Manager</th>
                    <th scope="col">Phone</th>
                    <th scope="col">State</th>
                    <th scope="col">City</th>
                    <th scope="col">Surveys Count</th>
                    <th style={{ width: "50px" }} />
                  </tr>
                </thead>
                <tbody>
                  {locations.map((location: Location) => (
                    <tr key={location.idLocation.toString()}>
                      <td>
                        <LocationLink location={location} />
                      </td>
                      <td>
                        <AccountLink account={location.account} />
                      </td>
                      <td>{location.siteManagerName}</td>
                      <td>{location.locationPhone}</td>
                      <td>{location.address?.state}</td>
                      <td>{location.address?.city}</td>
                      <td>{location.surveys.length}</td>
                      <td>
                        <i
                          className="ri-pencil-fill"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                          onClick={() => onEditClick(location)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Locations;
